/**
 * Accommodation card
 */


// deps
import PropTypes from 'prop-types';
import OwlCarousel from 'react-owl-carousel';
// import modal from '~/js/modules/magnific-popup';
import iconData from './data/amenityIconInformation';
import tooltipster from '~/js/modules/tooltipster';
// resort list context
const { resortList } = window.beaches_app.resortList;

// internals
const { Component } = React;
const internals = {};

internals.sliderOptions = {
  className: 'owl-theme',
  touchDrag: true,
  mouseDrag: true,
  lazyLoad: true,
  nav: true,
  items: 1,
  loop: true,
  dots: false,
  navText: ["<div class='slider-arrow slider-arrow-prev'></div>", "<div class='slider-arrow slider-arrow-next'></div>"]
};

export default class AccommodationCard extends Component {
  static propTypes = {
    roomInformation: PropTypes.object.isRequired,
    isListView: PropTypes.bool,
    modalId: PropTypes.string.isRequired,
    updateModal: PropTypes.func.isRequired,
    villageCode: PropTypes.string,
    roomDetailURI: PropTypes.object,
    isFiltered: PropTypes.bool
  };

  static defaultProps = {
    roomInformation: {},
    isListView: false,
    modalId: '',
    villageCode: '',
    roomDetailURI: {},
    updateModal: () => { },
    includeResortParam: false,
    isFiltered: false
  };

  componentDidMount() {
    tooltipster();
  }

  _renderPromotions = (promotion = {}) => {
    const { title = '', description = '', roomCategoryId = '', id: promotionId = '' } = promotion;
    const { modalId, updateModal } = this.props;

    return (
      <li key={`${roomCategoryId}-${promotionId}`}>
        <a href={`#${modalId}`} onClick={updateModal(title, description)} className="js-magnific-popup opensans-bold color-373737 font-1-4rem display-block">
          {title}
        </a>
      </li>
    );
  }

  _getAmenities = (room = {}, features = []) => {
    const amenityList = [
      'rollsRoyceTransfer', 'privateCarTransfer', 'roomService',
      'concierge', 'butler', 'handicapFriendly',
      'loveNest', 'choicePremiumSpirits', 'premiumSpirits',
      'beerWine', 'airportTransfers', 'washer','vipArrivalService'
    ];
    const amenityFeaturedList = ['Free Wifi', 'Soaking Tubs'];

    return [
      ...amenityFeaturedList.filter(amenity => features.some((el) => el.name === amenity)),
      ...amenityList.filter(amenity => room[amenity] === true)
    ];
  }

  createIBMTag = (resortShortName, code, name) => {
    // const viewType = this.props.isFiltered ? 'Filtered' : 'Booking';

    // window.cmCreateProductviewTag(
    //   resortShortName + ' : ' + code,
    //   resortShortName + ' : ' + name,
    //   resortShortName, viewType
    // );

    return true;
  }

  _renderAmenities = (room = {}, features = []) => {
    const amenities = this._getAmenities(room, features);

    return amenities.map(amenity => {

      const { className, popover, featureName } = iconData[amenity];

      return (
        <li key={['icon', room.roomCategoryCode, amenity].join('-')} data-tooltip-content={'#' + popover} className="inline-block pr tooltip ammenity-icon-container bg-ededed">
          <i className={className} />
          <span className="sr-only">{featureName}</span>
        </li>
      );
    });
  }

  render() {
    const { roomInformation, isListView, roomDetailURI, villageCode, includeResortParam } = this.props;
    const {
      attributes = [],
      code = '',
      name = '',
      description = '',
      maxOccupants = 0,
      webImageCode: firstSlide = '',
      additionalImageCodes: remainingImages = [],
      resortCode,
      loveNest: isTogetherNest,
      views = []
    } = this.props.roomInformation;
    const sliderImages = [firstSlide, ...remainingImages];
    const { sliderOptions } = internals;
    const roomDetailURL = `${roomDetailURI[villageCode.toLowerCase()]}detail?categoryCode=${code}${(includeResortParam) ? `&resortCode=${resortCode}` : ''}`;
    const resortShortName = resortList.find(x => x.code === roomInformation.resortCode).shortName;

    return (
      <div className={`xs-12 ${isListView ? 'accommodation-wrapper' : 'lg-6 xxl-4'}`}>
        <div className="row">
          <div className={`${isListView ? 'lg-6 xxl-4' : 'xs-12'}`}>
            <article className="accommodation-card pr">
              <div className="row">
                <div className="xs-12">
                  <OwlCarousel {...sliderOptions}>
                    {
                      sliderImages.map(imageCode => {
                        const cdnFilePath = `//cdn.sandals.com/beaches/v11/media/${resortCode.toLowerCase()}/accommodations/medium/${resortCode.toLowerCase()}-${imageCode}-medium.jpg`;

                        return (
                          <img key={`image-${resortCode + imageCode}`} className="owl-lazy" data-src={cdnFilePath} alt="" />
                        );
                      })
                    }
                  </OwlCarousel>
                  <div className="row">
                    <div className="xs-12">
                      <p className={`accommodation-name opensans-semibold color-white bg-373737 ${isListView ? 'hide' : ''}`}>{`${name} - ${code}`}</p>
                      <h6 className="font-1-4rem opensans-semibold accommodation-additional-info txt-left">
                        <span className="color-blue">MAX OCCUPANCY: </span>{maxOccupants}
                      </h6>
                      {
                        views.length > 0 && <h6 className="font-1-4rem opensans-semibold accommodation-additional-info room-view txt-left">
                          <span className="color-blue">ROOM VIEW: </span>{views.join(', ') || ''}
                        </h6>
                      }
                      <ul className="amenities-list">
                        {
                          this._renderAmenities(this.props.roomInformation, attributes)
                        }
                      </ul>
                      <a
                        href={roomDetailURL}
                        className="ib accommodation-details-link color-373737"
                        onClick={() => {
                          this.createIBMTag(resortShortName, code, name);
                        }}
                      >
                        Room Details <i className="icon-button-arrow-next color-blue" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </article>
          </div>
          <div className="xs-6 xxl-8">
            <div className="row">
              <div className={`accommodation-information txt-left ${isListView ? 'lg-12' : 'hide'}`}>
                <h5 className="accommodation-information-ttl opensans-semibold">{`${name} - ${code}`}</h5>
                <p className="accommodation-information-desc" dangerouslySetInnerHTML={{ __html: description }} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
//  hidden-xlarge-down
